var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "offcanvasResponsive",
      staticClass:
        "offcanvas-lg offcanvas-start side-bar order-2 order-lg-1 col-lg-3 offset-lg-0 p-0",
      attrs: {
        tabindex: "-1",
        id: "offcanvasResponsive",
        "aria-labelledby": "offcanvasResponsiveLabel",
      },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "offcanvas-body" }, [
        _vm.sideBarLeft === "lectureList"
          ? _c("div", { staticClass: "border-lg-end w-100" }, [
              _c(
                "div",
                { staticClass: "side-bar--overflow lecture-list" },
                [
                  _vm.logo
                    ? _c("div", { staticClass: "my-4 mx-4" }, [
                        _c(
                          "div",
                          { staticClass: "logo text-center" },
                          [
                            _vm.layoutType === 0
                              ? _c("a", { attrs: { href: _vm.back } }, [
                                  _c("img", {
                                    staticClass: "img-fluid",
                                    staticStyle: { "max-height": "120px" },
                                    attrs: { src: _vm.logo, alt: "" },
                                  }),
                                ])
                              : _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "course",
                                        params: {
                                          course: _vm.$route.params.course,
                                        },
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      staticStyle: { "max-height": "120px" },
                                      attrs: { src: _vm.logo, alt: "" },
                                    }),
                                  ]
                                ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "my-5 mx-4" }, [
                    _c("div", { staticClass: "progress" }, [
                      _c(
                        "div",
                        {
                          staticClass: "progress-bar text-bg-dark",
                          style: `width: ${_vm.progress}%`,
                          attrs: {
                            role: "progressbar",
                            "aria-valuenow": _vm.progress,
                            "aria-valuemin": "0",
                            "aria-valuemax": "100",
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.progress) +
                              "%\n            "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.sections, function (section) {
                    return _c(
                      "div",
                      { key: section.id, staticClass: "mb-4 mt-4" },
                      [
                        _c(
                          "div",
                          { staticClass: "lecture-list--section px-4 d-flex" },
                          [
                            _c("div", { staticClass: "h6 fw-bold me-auto" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(section.title) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            section.delay_days
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center me-2",
                                  },
                                  [_c("i", { staticClass: "far fa-clock" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleLectures(section)
                                  },
                                },
                              },
                              [
                                section.hide_lectures
                                  ? _c("i", {
                                      staticClass: "fas fa-angle-down",
                                    })
                                  : _c("i", { staticClass: "fas fa-angle-up" }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "transition",
                          { attrs: { tag: "div", name: "list" } },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !section.hide_lectures,
                                    expression: "!section.hide_lectures",
                                  },
                                ],
                                key: "container",
                              },
                              _vm._l(section.lectures, function (lecture) {
                                return _c("Lecture", {
                                  key: lecture.id,
                                  attrs: { lecture: lecture },
                                })
                              }),
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.exam
                    ? _c("div", { staticClass: "mb-4 mt-4 pointer" }, [
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "px-3" }, [
                          _c(
                            "div",
                            { staticClass: "h6 fw-bold" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm px-2 w-100 d-flex",
                                  attrs: {
                                    "active-class": "active",
                                    to: {
                                      name: "exam",
                                      params: {
                                        course: _vm.$route.params.course,
                                        exam: _vm.exam,
                                      },
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm._f("translate")("Exam")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "offcanvas-header" }, [
      _c("h5", {
        staticClass: "offcanvas-title",
        attrs: { id: "offcanvasResponsiveLabel" },
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "btn-close",
        attrs: {
          type: "button",
          "data-bs-dismiss": "offcanvas",
          "data-bs-target": "#offcanvasResponsive",
          "aria-label": "Close",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }